import React from 'react'

// GraphQL
import { useQuery } from '@apollo/client'
import query from './query.graphql'

const withQuery = WrappedComponent => {
  return props => {
    const {
      camper, // from parent
      session, // from parent
      camperSession,
      cartProduct,
      setCartProductDefault, // from redux actions
      notify, // from redux actions
      onQueryError // via withQueryResults
    } = props

    const { location } = cartProduct

    // react hooks
    const { loading, data } = useQuery(query, {
      variables: {
        sessionId: session.id,
        camperId: camper.id,
        locationId: location.id
      },
      onCompleted: data => {
        // store all eligible products for this camper and session
        const { sessions } = data || {}
        const product = sessions ? sessions[0].products[0] : null
        if (!product && !(session.breakType === 'backupcare')) {
          notify({
            variant: 'error',
            autoHide: false,
            message:
              'Sorry, this camper is not eligible to attend at this location.'
          })
        } else {
          setCartProductDefault({ camper, session, camperSession, product })
        }
      },
      onError: onQueryError
    })

    // GraphQL data
    const { sessions, appConfig } = data || {}
    const product = sessions ? sessions[0].products[0] : null
    const { enableCovidRequirements } = appConfig || {}

    return (
      <WrappedComponent
        loading={loading}
        product={product}
        enableCovidRequirements={enableCovidRequirements}
        {...props}
      />
    )
  }
}

export default withQuery
